import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useOneRequest } from 'src/utils/hooks/useOneRequest';
import { apiGetOrganizationVerifyData } from 'src/api/organization';
import { UiLoader } from 'src/components/UI/loaders';

import { OrganizationOldVerifyComponent } from 'src/pages/Organization/OldVerify/component';

export const OrganizationOldVerifyPage: FC = () => {
  const { permanenturl } = useParams<{ permanenturl: string }>();

  const { loading, response: model } = useOneRequest(apiGetOrganizationVerifyData, {
    initialCall: true,
    data: { id: permanenturl },
  });

  if (loading) {
    return <UiLoader fullScreenCentered />;
  }
  return <OrganizationOldVerifyComponent model={model} />;
};
